import { render, staticRenderFns } from "./BillableRateManagementDetailDetail.vue?vue&type=template&id=05c85c06&scoped=true"
import script from "./BillableRateManagementDetailDetail.vue?vue&type=script&lang=js"
export * from "./BillableRateManagementDetailDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c85c06",
  null
  
)

export default component.exports